module.exports = __webpack_public_path__ + "static/media/Layer3.a47e4a5d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Layer3.png
// module id = 55
// module chunks = 0